import { type TFunction } from 'i18next';
import { z } from 'zod';

import { HcpSchema } from '@/core/graphql/generated/validation.zod';

import { MultiPrimaryItemSchema } from '../MultiPrimaryItemSchema.validation';

type LocalSpecialtyData = {
	allSpecLocal_VId?: Array<{ id?: string | null }> | null;
};

export const validateLocalSpecialtyRequired =
	(t?: TFunction) => (data: LocalSpecialtyData, ctx: z.RefinementCtx) => {
		const hasOne = (data.allSpecLocal_VId ?? []).some(
			item => item.id && item.id.trim() !== ''
		);

		if (!hasOne) {
			ctx.addIssue({
				code: 'custom',
				message: t
					? t('At least one selection is required')
					: 'At least one selection is required',
				path: ['allSpecLocal_VId', 0, 'id']
			});
		}
	};

export const ProfessionalSectionSchema = (t?: TFunction) => {
	const raw = HcpSchema().pick({
		hcpType: true,
		statusCda_V: true,
		nhidCda_V: true
	});

	const requiredMsg = t
		? t('This field is required')
		: 'This field is required';

	return z
		.object({
			hcpType: z.string().min(1, { message: requiredMsg }),
			hcpTypeLocal_VId: z.string().nullish(),

			degrees: z.array(MultiPrimaryItemSchema).default([]),
			hcpSpecialties: z.array(MultiPrimaryItemSchema).default([]),

			allSpecLocal_VId: z.array(MultiPrimaryItemSchema).max(2).default([]),

			statusCda_V: raw.shape.statusCda_V
				.pipe(z.string().catch(''))
				.transform(s => s.trim()),

			nhidCda_V: z.string().nullish(),
			nhid2_V: z.string().nullish()
		})
		.strict()
		.superRefine(validateLocalSpecialtyRequired(t));
};

export type ProfessionalSectionValuesIn = z.input<
	ReturnType<typeof ProfessionalSectionSchema>
>;
export type ProfessionalSectionValuesOut = z.output<
	ReturnType<typeof ProfessionalSectionSchema>
>;
